import React from "react";
import "./SharkBanner.css"; // Add styling for animations

const SharkBanner = () => {
  return (
    <div className="shark-banner">
      <h1 className="shark-text">Angel Investor</h1>
    </div>
  );
};

export default SharkBanner;
